import React, { useState, useEffect, useMemo, useCallback } from 'react';
import GraphDaySelect from '../specific/GraphDaySelect';
import MultiWorkLineChart from '../specific/MultiWorkLineChart';
import {
    extractUniqueDaysFromReportData,
    buildMultiWorkChartData,
} from '../../usecases/graphMultiWorkUtils';

/** Por trabalho: prioriza plantio > pulverização > GPS. */
const getHaHoraSource = (workData) => {
    const histPlantio = workData?.[2]?.histPlantio;
    if (Array.isArray(histPlantio) && histPlantio.length > 0) {
        return { items: histPlantio, field: 'plp_hah' };
    }
    const histPulv = workData?.[1]?.histPulv;
    if (Array.isArray(histPulv) && histPulv.length > 0) {
        return { items: histPulv, field: 'pup_hah' };
    }
    const histGps = workData?.[4]?.histGps;
    if (Array.isArray(histGps) && histGps.length > 0) {
        return { items: histGps, field: 'gps_hah' };
    }
    return { items: [], field: null };
};

const getSourceItems = (workData) => getHaHoraSource(workData).items;

const getValue = (item, workData) => {
    const { field } = getHaHoraSource(workData);
    if (!field || item?.[field] == null) {
        return null;
    }
    const value = Number(item[field]);
    return Number.isNaN(value) ? null : value;
};

const GraphHaHora = ({ data, isPrinting }) => {
    const [selectedDay, setSelectedDay] = useState('');

    const uniqueDays = useMemo(
        () => extractUniqueDaysFromReportData(data, getSourceItems, 'data'),
        [data]
    );

    useEffect(() => {
        setSelectedDay((prev) => (!prev || !uniqueDays.includes(prev) ? (uniqueDays[0] || '') : prev));
    }, [uniqueDays]);

    const { chartData, series, yDomain } = useMemo(
        () => buildMultiWorkChartData({
            data,
            selectedDay,
            getSourceItems,
            dateField: 'data',
            getValue,
        }),
        [data, selectedDay]
    );

    const handleDayChange = useCallback((e) => setSelectedDay(e.target.value), []);

    return (
        <div>
            <h3>Rendimento de hectáres por hora</h3>
            <GraphDaySelect
                selectedDay={selectedDay}
                uniqueDays={uniqueDays}
                onChange={handleDayChange}
                isPrinting={isPrinting}
            />
            <MultiWorkLineChart chartData={chartData} series={series} yDomain={yDomain} />
        </div>
    );
};

export default GraphHaHora;
